/*
 * 一个图片组件
 *
 * @Author: fan.li@zuolin.com
 * @Date: 2019-08-15 10:53:37
 * @Last Modified by: fan.li@zuolin.com
 * @Last Modified time: 2020-01-03 10:58:21
 */

import * as React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Modal } from 'antd';

import './index.less';
import ErrorImage from 'images/80X80_errorImage.png';

const prefixCls = 'biz-image-component-component';

export default class ImageComponent extends React.Component {
	constructor (props) {
		super(props);

		this.state = {
			src: props.src,          // img的src
			isPreviewVisible: false, // 预览是否可见
		};
	}

	componentWillReceiveProps (nextProps) {
		const { src: nextSrc } = nextProps;
		const { src } = this.props;
		if (nextSrc !== src) {
			this.setState({ src: nextSrc });
		}
	}

	// img加载错误
	onImageError = () => {
		this.setState({ src: ErrorImage });
	}

	// 取消预览
	handlePreviewModalCancel = () => {
		this.setState({ isPreviewVisible: false });
	}

	// 预览图片
	handleShowPreviewModal = () => {
		this.setState({ isPreviewVisible: true });
	}

	render () {
		const { className, canPreview, ...rest } = this.props;
		const { src, isPreviewVisible } = this.state;

		const wrapCls = classnames(prefixCls, className);

		return (
			<React.Fragment>
				<img
					{...rest}
					className={wrapCls}
					src={src}
					onError={this.onImageError}
					onClick={this.handleShowPreviewModal}
				/>

				{/** 预览 */}
				<Modal
					visible={isPreviewVisible && canPreview}
					footer={null}
					onCancel={this.handlePreviewModalCancel}
				>
				  <img alt="preview" style={{ width: '100%' }} src={src} />
				</Modal>
			</React.Fragment>
		);
	}
}

ImageComponent.defaultProps = {
	canPreview: false,
	src: ErrorImage
};

ImageComponent.propTypes = {
	className: PropTypes.string, // className
	src: PropTypes.string,       // 图片地址
	canPreview: PropTypes.bool,  // 是否可以预览图片
};
